import React from "react";
import { connect } from "dva";
import { formatPrice } from "@/utils/utils";

const SecurePassDescription = ({ securePassThreshold }) => {
  const threshold = formatPrice(securePassThreshold, "en-US", "USD", 0);
  return (
    <div style={{ lineHeight: 1.6 }}>
      <h2>What is this?</h2>
      <p>
        <strong>SecurePass™</strong> is Autosled&apos;s digital gate pass system, built to improve vehicle shipment
        security and ensure a smooth handoff process. It uses real-time identity verification, dynamic QR codes, and
        tamper-resistant documentation to confirm that only authorized individuals can pick up and transport vehicles.
      </p>

      <p>
        To support this, we ask that a contact email be provided—ideally when the shipment is created, but it can be
        added later if needed. The digital gate pass will be sent directly to the pickup location, and it&apos;s
        important that the location uses it and follows the outlined process to help prevent theft and ensure a secure
        transfer.
      </p>
      <br />
      <h2>How do I use it?</h2>
      <div>
        SecurePass™ can be applied to shipments through one of the three options below. These options will be selectable
        in a dropdown when creating or editing shipments. For more information about these options and the SecurePass™
        process, please see{" "}
        <a
          href="https://autosled.com/SecurePass"
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          here
        </a>{" "}
      </div>
      <br />
      <div>
        <ol style={{ listStyle: "decimal", paddingLeft: "1.5em" }}>
          <li style={{ marginBottom: "0.75em" }}>
            <div>
              <strong>Do not use SecurePass</strong>
            </div>
            <div style={{ paddingLeft: "1em" }}>Do not apply SecurePass™ for this shipment.</div>
          </li>
          <li style={{ marginBottom: "0.75em" }}>
            <div>
              <strong>Use SecurePass for High Value Vehicles</strong>
            </div>
            <div style={{ paddingLeft: "1em" }}>
              Apply SecurePass™ only for vehicles with an MSRP above the configured threshold. ({`${threshold}`})
            </div>
          </li>
          <li>
            <div>
              <strong>Use SecurePass</strong>
            </div>
            <div style={{ paddingLeft: "1em" }}>Apply SecurePass™ for this shipment, regardless of vehicle MSRP.</div>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default connect(({ configs }) => ({
  securePassThreshold: configs.securePass.threshold,
}))(SecurePassDescription);
